/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type DocumentExportPublicStatus =
    (typeof DocumentExportPublicStatus)[keyof typeof DocumentExportPublicStatus];

export const DocumentExportPublicStatus = {
    Queued: 'queued',
    Processing: 'processing',
    Completed: 'completed',
    Failed: 'failed',
    Expired: 'expired',
} as const;
